import chatReducer from './features/chat/slice';
import { combineReducers } from '@reduxjs/toolkit';
import meetingReducer from './features/meeting/slice';
import projectsReducer from './features/projects/slice';
import gibTypesReducer from './features/gib-types/slice';
import usedBanksReducer from './features/used-banks/slice';
import permissionsReducer from './features/permissions/slice';
import connectionTypesReducer from './features/connection-types/slice';
import salesStageTypesReducer from './features/sales-stage-types/slice';
import environmentTypesReducer from './features/environment-types/slice';
import customerSourceTypesReducer from './features/customer-source-types/slice';

const rootReducer = combineReducers({
  chat: chatReducer,
  meeting: meetingReducer,
  gibTypes: gibTypesReducer,
  projects: projectsReducer,
  usedBanks: usedBanksReducer,
  permissions: permissionsReducer,
  connectionTypes: connectionTypesReducer,
  salesStageTypes: salesStageTypesReducer,
  environmentTypes: environmentTypesReducer,
  customerSourceTypes: customerSourceTypesReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
